export const homeGridItems = [
	{
		link   : '/bistrot',
		imgSrc : 'boucher-home.jpg',
		alt    : 'boucher',
		title  : 'bistrot'
	},
	{
		link   : '/quixote',
		imgSrc : 'quixote-home.jpg',
		alt    : 'quixote',
		title  : 'quixote'
	},
	{
		link   : '/myco',
		imgSrc : 'myco-1-home.jpg',
		alt    : 'myco',
		title  : 'myco'
	},
	{
		link   : '/eclectica',
		imgSrc : 'walrus-home.jpg',
		alt    : 'walrus',
		title  : 'eclectica'
	}
]

export const bistrotImages = [
	{
		imgSrc : 'liberte-2x3-twistd.jpg',
		alt    : 'liberte twistd'
	},
	{
		imgSrc : 'metro-3x2-stained-glass.jpg',
		alt    : 'metro stained glass'
	},
	{
		imgSrc : 'swans-2x3-posterize.jpg',
		alt    : 'swans posterize'
	}
]

export const quixoteImages = [
	{
		imgSrc : 'sky-3-3x2-solarize.jpg',
		alt    : 'sky solarize'
	},
	{
		imgSrc : 'sky-2-3x2-rekt.jpg',
		alt    : 'sky rekt'
	},
	{
		imgSrc : 'aurore-3x2.jpg',
		alt    : 'aurore'
	},
	{
		imgSrc : 'nest-2x3-cutout.jpg',
		alt    : 'nest cutout'
	},
	{
		imgSrc : 'sky-1-3x2-filter.jpg',
		alt    : 'sky filter'
	},
	{
		imgSrc : 'sky-4-3x2.jpg',
		alt    : 'sky'
	}
]

export const mycoImages = [
	{
		imgSrc : 'myco-2-3x2.jpg',
		alt    : 'myco two'
	},
	{
		imgSrc : 'myco-3-2x3-extrude.jpg',
		alt    : 'myco three'
	}
]

export const eclecticaImages = [
  {
    imgSrc : 'camino-3x2.jpg',
    alt    : 'camino'
  }
]
